import { useNavigate } from "react-router";
import styled from "styled-components";
import { theme } from "../../../helpers/theme";

const AccessDenied = () => {
  let navigate = useNavigate();
  return (
    <PageContainer>
      <AccessDeniedInfo>
        Nie posiadasz dostępu do przeglądania treści
      </AccessDeniedInfo>
      {/* <AccessDeniedRedirect onClick={() => navigate(-1)}>
        Wróć
      </AccessDeniedRedirect> */}
    </PageContainer>
  );
};

export default AccessDenied;

const PageContainer = styled.div`
  width: 80%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 400px;
`;
const AccessDeniedInfo = styled.span`
  font-weight: bold;
  font-size: 2rem;
  @media ${theme.device.Mtablet} {
    font-size: 1.6rem;
  }
  margin-bottom: 20px;
`;
const AccessDeniedRedirect = styled.span`
  font-weight: bold;
  font-size: 1.6rem;
  @media ${theme.device.Mtablet} {
    font-size: 1rem;
  }
  color: ${theme.colors.blue01_active};
  cursor: pointer;
`;
